import {useMemo,useEffect,useState,useRef } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component';
import suggestion from './suggestion.js'
import { EditorContent, useEditor, useEditorState } from '@tiptap/react'
import Mention from '@tiptap/extension-mention'
import StarterKit from "@tiptap/starter-kit";

import {useGetProcessFromInstanceQuery,usePublishProcessInstanceDataMutation,useLoadUserQuery,
		useCompleteProcessStateMutation,databaseViewApi,useAddCommentMutation,useLoadCommentsQuery,
		useListInstanceFormsQuery,useListInstanceStateDataQuery,useGetMemberAccessQuery,
		useCreateProcessStateEntryMutation} from './redux/databaseView';

import {useGetLoginStatusQuery		} from './redux/authApi';

function CommentLine({children})
	{
	return (<div style={{textAlign:'left',width:'100%',borderWidth:1,borderColor:'black'}}>{children}</div>)
	}

function MyEditor({instance}) 
	{
	const [addComment]=useAddCommentMutation();
	const userData=useLoadUserQuery();
	const suggestionListRoot=useRef([]);
//	console.log(userData);
	//console.log(JSON.stringify(suggestionListRoot.current));
	function suggestions({ query })
		{
//		console.log(query);
		var s=suggestionListRoot.current
		.filter(item => item.toLowerCase().startsWith(query.toLowerCase()))
		.slice(0, 5);
//		console.log(s);
		return s;		
		}

	suggestion.items=suggestions;
//	console.log(suggestion);
	useEffect(()=>{
		if (!userData.isSuccess)
			return;
		
		var suggestionList=userData.data.data.map((x)=>(x.name));
//		console.log(suggestionList);
		suggestionListRoot.current=suggestionList;
		},[userData.isSuccess]);
	const editor = useEditor({
						extensions: [
							StarterKit,	
							Mention.configure({
										HTMLAttributes: {class: 'mention'},
										suggestion,
										renderLabel: ({ options, node })=>{
											return `${node.attrs.label ?? node.attrs.id}`
											},
										}),
									],
						content: `
								  <p>
									Time your comments here use @ to tag <span data-type="mention" data-id="Ann Schwartz"></span> and press shift enter to submit
								  </p>
    `,
						editorProps: {
							handleKeyDown(view, event) 
								{
								if (event.key === "Enter" && event.shiftKey) 
									{
									const hasSuggestion = editor?.storage?.mention?.$isOpen || false;
//									console.log(editor,editor?.storage,editor?.storage?.mention)
									if (hasSuggestion) 
										{
										// let mention plugin handle Enter
										return false
										}
									// 🚀 Your custom function
									const text = view.state.doc.textContent
									var html=editor.getHTML();
									var clean = html.replace(/^<p>/, '').replace(/<\/p>$/, '')
									addComment({comment:clean,instance});
									event.preventDefault()
//									console.log("Submitted:", text)
									
									// Clear the editor
									view.dispatch(
										view.state.tr.replaceWith(
											0,
											view.state.doc.content.size,
											view.state.schema.nodes.paragraph.create()
											)
										)
									return true
									}
								return false
								},
							},
						})
	return (<EditorContent editor={editor} />);
	}

export function CommentBox({onEnter,instance})
	{
	function fetchData(){}
	function refresh(){}
	var items=[];//=[{comment:'test1'},{comment:'test2'}];
	const [commentValue,setValue]=useState("");
	const [addComment]=useAddCommentMutation();
	const comments=useLoadCommentsQuery({instance});
	const userList=useLoadUserQuery();
	const myid=useGetLoginStatusQuery();
	const displayID=useMemo(()=>{
			if (!myid.isSuccess||!userList.isSuccess)
				return null;
//			console.log(userList.data.data);
//			console.log(myid.data.data);
			var displayName=null;
			userList.data.data.some((x)=>{
				if (x.id==myid.data.data)
					{
					displayName=x.displayName?x.displayName:x.name;
					return true;
					}
				return false;
				})
			
			return displayName;
			},[myid.isSuccess,userList.isSuccess]);
//	console.log(displayID);
//	console.log(displayID);
	const handleKeyDown = (e) => {
		if (e.key === "Enter") 
			{
			e.preventDefault(); // avoid newline/form submit
			if (commentValue.trim()) 
				{
				addComment({comment:commentValue,instance});
				onEnter?.(commentValue.trim()); // trigger your callback
				setValue("");            // clear if desired
				}
			}
		};
	//console.log(comments);
	if (comments.isSuccess)
		{
//		console.log("loaded",comments.data.data);
		items=comments.data.data;
		if (items.length==0)
			items=[{hide:true,comment:"No comments yet"}];
		}
	return (<>
		<div id="scrollableDiv" style={{}}>
		<InfiniteScroll
		style={{marginBottom:20,height:200,maxHeight:200,overFlow:'auto'}}
		scrollableTarget="scrollableDiv"
		dataLength={items.length} //This is important field to render the next data
		next={fetchData}
		hasMore={true}
		loader={<h4>Loading...</h4>}
		endMessage={
			<p style={{ textAlign: 'center' }}>
				<b>Yay! You have seen it all</b>
			</p>
			}
  // below props only if you need pull down functionality
		refreshFunction={refresh}
		pullDownToRefresh
		pullDownToRefreshThreshold={50}
		pullDownToRefreshContent={
			<h3 key="pullDownToRefreshContent" style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
			}
		releaseToRefreshContent={
			<h3 key="releaseToRefreshContent" style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
			}
		>

		{items.map((x,idx)=>{  		//assume if we don't have a name it must be a new comment made by oourself 
			var textStr="";
			if (!x?.hide)
				textStr=(x.displayName?x.displayName:displayID)+": ";
			return (<CommentLine key={idx}>
				<strong  style={{whiteSpace: 'nowrap'}}>{textStr}</strong>
				<div style={{display:'inline'}} dangerouslySetInnerHTML={{ __html: x.comment?x.comment:null }}></div>
				</CommentLine>)
				})}
	</InfiniteScroll>
	</div>
	<MyEditor instance={instance}/>
	</>
	)
	}
	
/*
	<TextField fullWidth id="outlined-basic" label="Comment" variant="outlined" 
		value={commentValue} 
		onChange={(e) => setValue(e.target.value)}
		onKeyDown={handleKeyDown}/>
	</>
*/


